import { isObject, isFunction } from 'lodash'
import { injectQueryTableCallMethods } from './proxy'
import { mapGetters } from 'vuex'
import { SCROLLBAR_POSITION } from '../../kye-table2/config'

import CallDialog from '../../kye-field-call/call-dialog.vue'
import { getTextFlexDisabled, deptIndent, getTextFlexCurrentLevel, extractMaxLevelFromRowData } from './feature/text-flex-render'
import { createCellClassName } from './feature/cell-class'
import { decryptPlugin } from './feature/cell-decrypt/decrypt-plugin'
import { getTable2Props } from './props'
import './index.scss'
import { table2WrapPluginsFactory } from './plugins'
import { getMaxHeight, mergeColumns } from './config'

const decryptModule = decryptPlugin()

const table2WrapPluginsInstance = table2WrapPluginsFactory()

export default {
  name: 'Table2Wrap',
  components: {
    CallDialog
  },
  props: {
    data: Array,
    rowKey: {
      type: [String, Function]
    },
    tableConfig: {
      type: Object,
      default: () => ({})
    },
    maxDecryptConfig: Object,
    page: Object,
    pageable: Boolean,
    callProps: {
      type: Object,
      default: () => ({})
    },
    searchCode: String,
    maxHeight: Number,
    slotComponent: [Object, Function],
    tableName: String,
    dialog: Boolean,
    defaultSort: Object,
    expandedRowKeys: {
      type: Array,
      default: () => []
    },
    clearHScroll: {
      type: Boolean,
      default: true
    },
    offsetLeft: {
      type: Number,
      default: 0
    },
    options: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    const { tableConfig = {}, maxHeight: PropMaxHeight } = this.$props
    const { maxHeight } = tableConfig.option || {}
    return {
      prevPage: 1, // 记录当前表格分页
      formatColumns: [],
      textFlexWidgetCols: [],
      updateColumnsOptSign: false,
      tableFocus: false,
      maxHeightVal: parseInt(maxHeight || PropMaxHeight || 0),
      scrollOffsetLeft: 176,
      textFlexWidgetMap: {},
    }
  },
  created() {
    this.tableKey = `${this.$route.meta.tag}?${this.searchCode}`
    this.mergeColumns()
  },
  activated() {
    this.checkTableFocus()
  },
  mounted() {
    this.prevPage = this.currentPage
    injectQueryTableCallMethods(this)
    if (this.dialog && !this.maxHeight) {
      setTimeout(_ => {
        this.initMaxHeight()
      }, 310)
    } else {
      this.initMaxHeight()
    }
    this.$bus.$on('SWITCH_MENU', this.handleSwitchMenu)
    table2WrapPluginsInstance.register(this)
  },
  beforeDestroy () {
    this.$bus.$off('SWITCH_MENU', this.handleSwitchMenu)
    table2WrapPluginsInstance.destroy()
  },
  watch: {
    'tableConfig.columns': {
      handler() {
        this.mergeColumns()
      },
      deep: true
    },
    'tableConfig.drawColumnOptions': {
      handler() {
        this.mergeColumns()
      },
      deep: true
    },
    // 2023-02-28 表格动态自定义列 searchCode 场景
    searchCode () {
      this.tableKey = `${this.$route.meta.tag}?${this.searchCode}`
    },
    data(val) {
      // canvas表格滚动条数据变更后会重置，例如翻页
      if (this.prevPage !== this.currentPage && this.isClearHScroll) {
        this.scrollToTop()
        this.prevPage = this.currentPage
      }
      // 复用query-table老逻辑
      if (this.dialog && !this.maxHeight) {
        setTimeout(() => {
          this.initMaxHeight()
        }, 310)
      }
      // 数据发生变化时，需要重新计算伸缩部件的状态和最大层级
      this.changeTextFlexWidget(val)
      // 数据变化把scrollTop置顶
      // this.scrollToTop()
    },
    'tableConfig.option.maxHeight': {
      handler() {
        this.initMaxHeight()
      },
    },
  },
  computed: {
    ...mapGetters([
      'lookUpOptions',
      'permission'
    ]),
    scrollbarStyle () {
      return this.computedScrollbarStyle()
    },
    scrollbarPosition () {
      const { dialog, tableConfig } = this.$props
      const { option = {} } = tableConfig
      const { scrollbarPosition } = option
      return dialog ? (scrollbarPosition || SCROLLBAR_POSITION[0]) : SCROLLBAR_POSITION[1]
    },
    localExpandedRowKeys () {
      const { option } = this.$props.tableConfig || {}
      const { expandedRowKeys = [] } = option || {}
      return [...this.$props.expandedRowKeys, ...expandedRowKeys]
    },
    currentPage () {
      const { page } = this.$props
      const { currentPage = 1 } = page || {}
      return currentPage
    },
    isClearHScroll () {
      const { clearHScroll } = this.$props || {}
      const { option = {} } = this.$props.tableConfig || {}
      return !((clearHScroll === false || option.clearHScroll === false))
    }
  },
  render () {
    const { data, tableConfig, callProps, slotComponent, defaultSort } = this.$props
    const { option = {} } = tableConfig
    const rowKey = this.$props.rowKey || option.rowKey
    const attrs = {
      props: {
        ...getTable2Props(this),
        data,
        rowKey,
        scrollbarPosition: this.scrollbarPosition,
        indexMethod: this.indexMethod,
        defaultSort: isObject(defaultSort) ? defaultSort : undefined,
        scrollbarStyle: this.scrollbarStyle,
        maxHeight: this.maxHeightVal,
        tableName: this.$props.tableName,
        cellClassName: (params) => createCellClassName(params, option.cellClassName),
        expandedRowKeys: this.localExpandedRowKeys,
        fixedRowsTop: option.fixedRowsTop,
        fixedRowsData: option.fixedRowsData,
        footerRows: option.footerRows,
        disableHeadCheckbox: option.disableHeadCheckbox,
        mergeFixedRowsEqualCellsOption: option.mergeFixedRowsEqualCellsOption,
        mergeFooterRowsEqualCellsOption: option.mergeFooterRowsEqualCellsOption,
        dynamicRowSize: option.dynamicRowSize
      },
      ref: 'table',
    }
    const $scopedSlots = (isFunction(slotComponent) ? slotComponent() : slotComponent) || this.$scopedSlots
    const $slots = this.$slots
    return <div class="listbox" id="listbox_table2-wrap">
      <kye-table2
        {...attrs}
        on-cell-click={this.cellClick}
        on-row-click={this.rowClick}
        on-header-thead-mouseleave={this.headerMove}
        on-header-thead-mouseenter={this.headerMouseenter}
        on-table-leave={this.tableLeave}
        on-scroll={this.tableScroll}
        on-row-dblclick={this.rowDblclick}
        on-sort-change={this.sortChange}
        on-header-dragend={this.headerDragend}
        on-selection-change={this.selectionChange}
        on-select={this.select}
        on-select-all={this.onSelectAll}
        on-collapsed={this.collapsedChange}
        on-cell-mouse-enter={this.cellMouseEnter}
        on-cell-mouse-leave={this.cellMouseLeave}
        on-radio-change={this.radioChange}
        >
        {{
          ...$scopedSlots,
          ...$slots
        }}
      </kye-table2>
      <call-dialog
        ref="callDialog"
        {
          ...{
            props: callProps
          }
        }
        on-save={() => this.$emit('call-save')}>
      </call-dialog>
    </div>
  },
  methods: {
    handleSwitchMenu (width) {
      this.scrollOffsetLeft = width + 16
      this.$emit('switch-menu', width)
    },
    computedScrollbarStyle () {
      const { dialog, pageable, offsetLeft } = this.$props
      const bottom = pageable ? '44px' : 0
      const style = {
        horizontal: {
          position: 'fixed',
          bottom,
          left: this.scrollOffsetLeft + offsetLeft + 'px',
          right: '16px',
          'z-index': 10 // 保持一致 和query-table的设置
        }
      }
      return dialog ? null : style
    },
    toggleRowSelection(cb) {
      if (cb && typeof cb === 'function') {
        const tableData = this.getTableData()
        this.$nextTick(_ => {
          const selectMark = cb(tableData || [])
          if (Array.isArray(selectMark)) {
            this.clearSelection()
            selectMark.forEach((v, index) => {
              if (v) {
                const rowData = tableData[index]
                if (rowData) {
                  this.$refs.table.store.rowSelectedChanged(true, rowData)
                }
              }
            })
          }
        })
      }
    },
    getTableData() {
      return this.$refs.table.store._tableData
    },
    cellClick(params) {
      const { rowData, column } = params
      const { buttonOptions } = this.$props.tableConfig
      this.emitCellClick(params)
      this.handleDecrypt(params)
      // 特写兼容用户自定义了cell，又配置了buttonOptions，主要解决迁移场景
      const btnOpt = buttonOptions && buttonOptions[column.key]
      if (btnOpt && isFunction(btnOpt.func) && column.rowCellRender && !column.__innerCellRender) {
        btnOpt.func(rowData, params)
      }
    },
    emitCellClick (params) {
      const { rowData, column } = params
      this.$emit('cell-click', params, {
        isMask: decryptModule.DECRYPT_checkMaskInRow(rowData, column.key),
        isVirtual: decryptModule.DECRYPT_checkVirtualInRow(rowData, column.key),
      })
    },
    scrollToTop(scrollTop = 0) {
      this.$refs.table.scrollToTop(scrollTop)
    },
    scrollToLeft(scrollLeft = 0) {
      this.$refs.table.scrollToLeft(scrollLeft)
    },
    /**
     * @NOTE 处理table2加密字段解密成功的回调
     */
    handleDecryptSuccess(params) {
      const { buttonOptions } = this.$props.tableConfig
      this.$emit('decrypt-success', { ...params, vm: this.$refs.table, buttonOptions })
    },
    handleDecrypt (params) {
      const { drawColumnOptions, option: options } = this.$props.tableConfig
      const data = this.data
      const maxDecryptConfig = this.$props.maxDecryptConfig
      decryptModule.DECRYPT_handleDecryptAction({ ...params, data, drawColumnOptions, options, maxDecryptConfig, decryptSuccessFunc: this.handleDecryptSuccess })
    },
    headerMove (params) {
      this.$emit('header-move', params)
    },
    headerMouseenter (params) {
      this.$emit('header-enter', params)
    },
    tableLeave (params) {
      this.$emit('table-leave', params)
    },
    tableScroll (params) {
      this.$emit('table-scroll', params)
    },
    indexMethod (index) {
      const { page } = this.$props
      const { pageSize = 200, currentPage = 1 } = page || {}
      return pageSize * (currentPage - 1) + index
    },
    sortChange(params) {
      // clearSort不抛sort-change，对齐qt-canvas
      if (Object.keys(params).length) {
        const { page, pageable, tableConfig } = this.$props
        const { total, pageSize } = page || {}
        const { option = {} } = tableConfig || {}
        let autoSort = option.sortType === 'auto'
        let onePage = total <= pageSize || !pageable
        const { ...rest } = params
        // 本地排序的条件
        if (onePage && autoSort) {
          this.$refs.table.store.localSort(params.column)
        }
        this.$emit('sort-change', { ...rest, remote: !(onePage && autoSort) })
      }
    },
    createColumns (updateColumnsOpt = {}, option = {useWidthCache: true}) {
      const { tableConfig } = this.$props
      const { drawColumnOptions, columns, operation, buttonOptions, headerTipOptions } = tableConfig
      const localStorePreColumnsOpt = this.dragHistoryWidthPlugin ? this.dragHistoryWidthPlugin.getLocalStorePreColumnWidthMap() : {}
      const localStoreColumnsOpt = option.useWidthCache ? (this.dragHistoryWidthPlugin ? this.dragHistoryWidthPlugin.getLocalStoreUserActionWidthMap() : {}) : {}
      const tableKey = this.tableKey
      const updateColumnsOptSign = this.updateColumnsOptSign
      this.textFlexWidgetCols = []
      const textFlexWidgetCols = this.textFlexWidgetCols
      const formatColumns = mergeColumns(columns, {
        drawColumnOptions,
        updateColumnsOpt,
        vm: this,
        localStoreColumnsOpt,
        localStorePreColumnsOpt,
        tableKey,
        updateColumnsOptSign,
        operation,
        permission: this.permission,
        buttonOptions,
        textFlexWidgetCols,
        headerTipOptions
      })
      return formatColumns
    },
    setFormatColumns (formatColumns) {
      this.formatColumns = formatColumns
    },
    mergeColumns(updateColumnsOpt = {}, option) {
      this.textFlexWidgetCols = []
      const formatColumns = this.createColumns(updateColumnsOpt, option)
      this.setFormatColumns(formatColumns)
    },
    setTableColumns(updateColumnsOpt, option) {
      this.updateColumnsOptSign = true
      this.$nextTick(() => {
        if (isObject(updateColumnsOpt)) {
          this.mergeColumns(updateColumnsOpt, option)
          this.updateColumnsOptSign = false
        }
      })
    },
    callIconClick(rowData, column, value) {
      const { key } = column
      this.$refs.callDialog.init({
        callNumber: value,
        calledNumberEncrypt: rowData[`${key}Mask`] || rowData[`${key}Virtual`] || rowData[`${key}MaskSec`] || '',
        succsss: () => {
          this.$emit('call-success', { rowData, column })
        }
      })
      this.emitCellClick({ rowData, column, value })
    },
    rowDblclick (params) {
      console.log('rowDblclick', params)
      const { tableConfig } = this.$props
      const { option } = tableConfig
      const { rowData, column, value, eventType } = params
      if (option.rowDblClick) {
        let auth = option.detailAuth
        auth = auth === false || (auth && this.permission.menus.includes(auth))
        if (!auth) {
          this.$message.warning('无权访问')
          return
        }
        option.rowDblClick(rowData, column, value)
        if (eventType === 'enter') {
          this.tableFocus = true
        }
      }
    },
    headerDragend (...args) {
      this.$emit('header-dragend', ...args)
      this.$emit('column-width-change', ...args)
    },
    setScrollLeft (left) {
      this.$refs.table && this.$refs.table.scrollToLeft(left)
    },
    setScrollTop (top) {
      this.$refs.table && this.$refs.table.scrollToTop(top)
    },
    setCurrentRow(rowData) {
      this.$refs.table && this.$refs.table.setCurrentRow(rowData)
    },
    clearCurrentRow() {
      this.$refs.table && this.$refs.table.clearCurrentRow()
    },
    rowClick (params) {
      if (this.tableConfig.option && this.tableConfig.option.rowClick) {
        const { rowData, column, value, rowIndex } = params
        this.tableConfig.option.rowClick(rowData, column, value, rowData, rowIndex)
      }
    },
    selectionChange (...args) {
      if (!this.tableConfig.option) {
        return
      }
      if (this.tableConfig.option.type === 'selection' && this.tableConfig.option.selectionChange) {
        this.tableConfig.option.selectionChange(...args)
      }
    },
    // 复用query-table老逻辑
    handleDialogHeight () {
      // tabs+单行表单+工具栏+统计栏+弹框头部   38+32+30+32+44
      if (!this.$el) return 0
      let top = this.$el.offsetTop
      top = (top > 0 && top <= 176) ? top - 44 + 16 : 28
      return Math.floor(window.innerHeight * 0.6) - top
    },
    initMaxHeight() {
      const { tableConfig, dialog } = this.$props
      const { option = {} } = tableConfig
      const { maxHeight } = option
      this.maxHeightVal = getMaxHeight(maxHeight, this.$props.maxHeight, dialog, this)
    },
    checkTableFocus() {
      if (this.tableFocus) {
        this.tableFocus = false
        this.$refs.table && this.$refs.table.focus()
      }
    },
    setCanvasWidth () {
      this.$refs.table.$refs.tableContainer.throttleHandleResize()
    },
    textFlexDeptIndent(type, colKey) {
      const column = this.$refs.table.store.states.mainColumns.find(col => col.key === colKey)
      if (!column) {
        console.log('column不存在')
        return
      }
      const {
        canPlus,
        canSub
      } = getTextFlexDisabled(column)
      if (type === '-' && !canSub) {
        return
      }
      if (type === '+' && !canPlus) {
        return
      }
      return deptIndent(type, column)
    },
    changeCollapseKeys (key) {
      this.$refs.table.changeCollapseKeys(key)
    },
    collapsedChange (...args) {
      this.$emit('collapsed', ...args)
    },
    clearSort () {
      this.$refs.table && this.$refs.table.clearSort()
    },
    cellMouseEnter (...args) {
      this.$emit('cell-mouse-enter', ...args)
    },
    cellMouseLeave (...args) {
      this.$emit('cell-mouse-leave', ...args)
    },
    radioChange(...args) {
      const { radioChange } = this.tableConfig.option
      if (radioChange && typeof radioChange === 'function') {
        radioChange(...args)
      }
    },
    clearSelection () {
      this.$refs.table.clearSelection()
    },
    setSelectedInRows (...args) {
      this.$refs.table.setSelectedInRows(...args)
    },
    toggleAllSelection () {
      this.$refs.table.toggleAllSelection()
    },
    select (...args) {
      this.$emit('select', ...args)
    },
    onSelectAll(...args) {
      this.$emit('select-all', ...args)
    },
    changeTextFlexWidget (val) {
      // 数据发生变化时，需要重新计算伸缩部件的状态和最大层级
      this.textFlexWidgetMap = {}
      if (this.textFlexWidgetCols.length) {
        this.textFlexWidgetCols.forEach(col => {
          this.setTextFlexWidgetMap(col, val)
        })
      }
    },
    setTextFlexWidgetMap (col, data) {
      const { key } = col || {}
      if (!this.textFlexWidgetMap[key]) {
        const map = {
          TextFlexCurrentLevel: getTextFlexCurrentLevel(col),
          TextFlexMaxLevel: extractMaxLevelFromRowData(data, col)
        }
        this.$set(this.textFlexWidgetMap, key, map)
      }
    },
    setTextFlexWidgetCurrentLevel (key, val) {
      this.$set(this.textFlexWidgetMap[key], 'TextFlexCurrentLevel', val)
    }
  }
}



// WEBPACK FOOTER //
// ./src/public/components/query-table/table2/kye-table2-wrap.js